import { AFFILIATE_EARNINGS } from '../actionTypes';

export const fetchAffiliateEarnings = (action) => ({
  type: AFFILIATE_EARNINGS.FETCH,
  payload: action.payload,
});
